import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Breadcrumb } from "antd";
import { IMenu } from "src/common/types";
import "./MsBreadcrumb.scss";

interface PropsOwn {
  list: IMenu[]
}

// 合并props
type AllProps = PropsOwn & RouteComponentProps;

/**
 * 面包屑公共组件
 *
 * @class MsBreadcrumb
 * @extends {React.Component<AllProps>}
 */
class MsBreadcrumb extends React.Component<AllProps> {
  public onClick = (item: IMenu) => {
    this.props.history.push({pathname: item.link!, state: item.params});
  }

  public render() {
    return (
      <Breadcrumb className="ms-breadcrumb">
        {
          this.props.list && this.props.list.map((item: IMenu) => (
            <Breadcrumb.Item key={ item.code }>
              {
                item.link ? <a href="javascript:;" onClick={ this.onClick.bind(this, item) }>{ item.text }</a> : item.text
              }
            </Breadcrumb.Item>
          ))
        }
      </Breadcrumb>
    )
  }
}

export default withRouter(MsBreadcrumb);



// WEBPACK FOOTER //
// ./src/components/ms-common/ms-breadcrumb/MsBreadcrumb.tsx